export default __webpack_public_path__ + "static/media/dados.6a964d13.png";